import { useCallback, useState } from 'react';

/** Hook to easily implement flashing effect in list items, when we want to highlight that they have
 * changed somehow (e.g. their position has changed)
 *
 * @param duration The duration of the flash
 * @returns Whether the element is currently flashing (and should be styled appropriately), and a function to initiate the flash
 */
export const useFlash = (duration: number = 500): [boolean, () => void] => {
	const [isFlashing, setIsFlashing] = useState<boolean>(false);

	const flash = useCallback(() => {
		setIsFlashing(true);
		setTimeout(() => {
			setIsFlashing(false);
		}, duration);
	}, [duration]);

	return [isFlashing, flash];
};
